import React from 'react';

interface BorrowerIconProps {
  index: number;
}

export const BorrowerIcon: React.FC<BorrowerIconProps> = ({ index }) => {
  return (
    /* eslint-disable-next-line */
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
    >
      <path
        d="M38.7729 36.6833L45.6749 33.1554C47.009 32.4386 48.5726 32.7266 49.218 33.9264C49.8612 35.1262 49.296 36.6963 47.9619 37.4132L33.6425 45.0883L32.8845 45.2789L19.5288 45.6405C19.5288 45.6405 17.8092 46.1213 15.7432 48.4624"
        stroke="#00093A"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 41.4406L17.0574 35.864C20.0179 33.8672 23.5284 34.9695 23.5284 34.9695C25.2285 35.4178 28.386 35.5175 28.386 35.5175H33.627C35.1884 35.5175 36.4662 36.6328 36.4662 37.995C36.4662 39.3572 35.1884 40.4725 33.627 40.4725H26.3763"
        stroke="#00093A"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.137 31.6694C19.6297 29.5341 18.7461 26.9288 18.7461 24.1177C18.7461 20.4231 20.2772 17.0815 22.7353 14.6992"
        stroke="#00093A"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.417 12.1803C28.0759 11.4223 29.9189 11 31.8615 11C39.1057 11 44.979 16.8733 44.979 24.1153C44.979 26.6058 44.286 28.9339 43.0797 30.9177"
        stroke="#00093A"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {index === 0 ? (
        <path
          d="M32.0499 30.2682C31.5568 30.2682 31.1571 29.8684 31.1571 29.3754V17.8362C31.1571 17.3431 31.5568 16.9434 32.0499 16.9434C32.5429 16.9434 32.9427 17.3431 32.9427 17.8362V29.3754C32.9427 29.8684 32.5429 30.2682 32.0499 30.2682ZM29.2371 18.5562C28.7917 18.5562 28.4307 18.1951 28.4307 17.7498C28.4307 17.3044 28.7917 16.9434 29.2371 16.9434H31.9443C32.3896 16.9434 32.7507 17.3044 32.7507 17.7498C32.7507 18.1951 32.3896 18.5562 31.9443 18.5562H29.2371Z"
          fill="#DA291C"
        />
      ) : (
        <path
          d="M27.2998 29.2915L32.215 24.1075C32.7142 23.5955 33.1046 23.1539 33.3862 22.7827C33.6678 22.3987 33.8662 22.0467 33.9814 21.7267C34.1094 21.4067 34.1734 21.0739 34.1734 20.7283C34.1734 20.0499 33.9558 19.5187 33.5206 19.1347C33.0854 18.7507 32.5222 18.5587 31.831 18.5587C31.1526 18.5587 30.5574 18.7251 30.0454 19.0579C29.7552 19.2393 29.4835 19.4782 29.2303 19.7747C28.9057 20.1549 28.3325 20.2641 27.9484 19.944C27.6416 19.6883 27.5625 19.2429 27.802 18.9233C28.2428 18.3351 28.7474 17.8743 29.3158 17.5411C30.0582 17.0931 30.9158 16.8691 31.8886 16.8691C32.7078 16.8691 33.4182 17.0291 34.0198 17.3491C34.6342 17.6691 35.1078 18.1171 35.4406 18.6931C35.7734 19.2691 35.9398 19.9411 35.9398 20.7091C35.9398 21.2595 35.8694 21.7523 35.7286 22.1875C35.6006 22.6227 35.3638 23.0707 35.0182 23.5315C34.6854 23.9795 34.2182 24.5171 33.6166 25.1443L30.7801 28.063C30.0507 28.8136 29.0562 29.2484 28.0099 29.2741L27.2998 29.2915ZM28.3942 30.3859C27.7898 30.3859 27.2998 29.896 27.2998 29.2915L30.09 28.7731H35.4406C35.886 28.7731 36.247 29.1342 36.247 29.5795C36.247 30.0249 35.886 30.3859 35.4406 30.3859H28.3942Z"
          fill="#DA291C"
        />
      )}
    </svg>
    /* eslint-enable */
  );
};
